/// <amd-module name="Wit/WorkItemBuildLinks/BuildLinkUtils" />
import { Build, BuildResult, BuildStatus } from "Build/Client/Contracts/Build";
import * as Resources from "Wit/WorkItemBuildLinks/Resources";

export function getFriendlyBuildResult(result: BuildResult): string {
    switch (result) {
        case BuildResult.Succeeded:
            return Resources.BuildResultSucceeded;
        case BuildResult.PartiallySucceeded:
            return Resources.BuildResultPartiallySucceeded;
        case BuildResult.Failed:
            return Resources.BuildResultFailed;
        case BuildResult.Canceled:
            return Resources.BuildResultCanceled;
        case BuildResult.None:
            return Resources.BuildResultNone;
        default:
            assertNever(result);
    }
}

function getFriendlyBuildStatus(status: BuildStatus): string {
    switch (status) {
        case BuildStatus.Completed:
            return Resources.BuildStatusCompleted;
        case BuildStatus.InProgress:
            return Resources.BuildStatusInProgress;
        case BuildStatus.NotStarted:
            return Resources.BuildStatusNotStarted;
        case BuildStatus.Postponed:
            return Resources.BuildStatusPostponed;
        case BuildStatus.Cancelling:
            return Resources.BuildStatusCancelling;
        case BuildStatus.All:
            return Resources.BuildStatusAll;
        case BuildStatus.None:
            return Resources.BuildStatusNone;
        default:
            assertNever(status);
    }
}

export function getFriendlyState(build: Build): string {
    return build.status === BuildStatus.Completed ? getFriendlyBuildResult(build.result) : getFriendlyBuildStatus(build.status);
}

export function getUpdateTime(build: Build): Date {
    switch (build.status) {
        case BuildStatus.Completed:
            return build.finishTime;
        case BuildStatus.InProgress:
            return build.startTime;
        case BuildStatus.NotStarted:
        case BuildStatus.Postponed:
        case BuildStatus.Cancelling:
            return build.queueTime;
        case BuildStatus.All:
        case BuildStatus.None:
            return build.lastChangedDate;
        default:
            assertNever(build.status);
    }
}

function assertNever(arg: never): never {
    throw new Error(`This function should never be called but was called with ${arg}`);
}
